import { render, staticRenderFns } from "./DevicePropertiesList.vue?vue&type=template&id=b97a5408&scoped=true&"
import script from "./DevicePropertiesList.vue?vue&type=script&lang=ts&"
export * from "./DevicePropertiesList.vue?vue&type=script&lang=ts&"
import style0 from "./DevicePropertiesList.vue?vue&type=style&index=0&id=b97a5408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97a5408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VForm,VIcon,VTextField})
